<template>
  <header class="app-header navbar">
    <slot></slot>
  </header>
</template>
<script>
export default {
  name: 'app-navbar',
  created () {
    this._navbar = true
  }
}
</script>



// WEBPACK FOOTER //
// Navbar.vue?653c5099